import React, { useEffect, useState } from 'react';
import {
  Grid,
  styled,
  TextField,
  Paper,
  Button,
  Modal,
  Typography,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Box
} from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import PageHeader from '../../../components/PageHeader';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { EmailTemplate } from '../../../schema/email_template';
import { api } from '../../../api';
import {
  templateToHtml,
  mapKeywordsMeaning,
  defaultMapKeywords,
  EmailTemplateMapKeywords
} from '../../../util/email';

const mapKeywords = defaultMapKeywords;

const EditEmailTemplate: React.FC = () => {
  const navigate = useNavigate();
  const { email_template_id } = useParams();

  const [stepName, setStepName] = useState<string>('');
  const [recipientName, setRecipientName] = useState<string>('');
  const [subject, setSubject] = useState<string>('');
  const [body, setBody] = useState<string>('');
  const [isActive, setIsActive] = useState<boolean>(false);

  // const [recipientList, setRecipientList] = useState<EmailRecipient[]>([]);
  // const [stepList, setStepList] = useState<EmailStep[]>([]);

  const [isShowKeywordModal, setIsShowKeywordModal] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (isLoading) {
      return;
    }
    if (email_template_id && subject) {
      setIsLoading(true);
      api
        .put(`/email_template/${email_template_id}`, {
          // step_id: stepId,
          // recipient_id: recipientId,
          subject: subject,
          body: body,
          is_active: isActive
        })
        .then(() => {
          navigate('/email-management');
        })
        .finally(() => setIsLoading(false));
    }
  };

  // const handleDelete = () => {
  //   if (email_template_id) {
  //     api.delete(`/email_template/${email_template_id}`).then((res) => {
  //       const { data } = res;
  //       navigate('/email-management');
  //     });
  //   }
  // };

  useEffect(() => {
    if (email_template_id) {
      api.get<EmailTemplate>(`/email_template/${email_template_id}`).then((res) => {
        const { data } = res;
        setStepName(data.step.step_name);
        setRecipientName(data.recipient.recipient_name);
        setSubject(data.subject);
        setBody(data.body);
        setIsActive(data.is_active);
      });
    }
  }, [email_template_id]);

  // useEffect(() => {
  //   api.get<EmailRecipient[]>(`/email_recipient`).then((res) => {
  //     const { data } = res;
  //     setRecipientList(data);
  //   });
  //   api.get<EmailStep[]>(`/email_step`).then((res) => {
  //     const { data } = res;
  //     setStepList(data);
  //   });
  // }, []);

  return (
    <RootContainer>
      <PageHeader text="แก้ไข Email" />
      {/* <Container sx={{ mt: 3 }}> */}
      <Button component={Link} to="/email-management" sx={{ my: 3, p: 0 }}>
        <ArrowBackIosIcon />
        รูปแบบ E-mail
      </Button>

      <Paper>
        <Typography variant="h6" sx={{ px: 2, pt: 2, pb: 1 }}>
          {'แก้ไขข้อมูล'}
        </Typography>

        <Form onSubmit={handleFormSubmit} sx={{ padding: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <TextField
                fullWidth
                label="ขั้นตอน"
                variant="outlined"
                placeholder="ขั้นตอน"
                value={stepName}
                InputProps={{ readOnly: true }}
                disabled={true}
                sx={{
                  '.Mui-disabled': {
                    color: '#65748B',
                    opacity: 1,
                    '-webkit-text-fill-color': '#65748B'
                  },
                  '.MuiInputLabel-root': {
                    color: '#65748B',
                    '-webkit-text-fill-color': '#65748B'
                  }
                }}
              />
              {/* <FormControl fullWidth>
                <InputLabel>ขั้นตอน</InputLabel>
                <Select
                  label="ขั้นตอน"
                  variant="outlined"
                  onChange={(e) => setStepId(parseInt(e.target.value))}
                  value={`${stepId}`}
                  autoComplete="off"
                  required
                >
                  {stepList.map((data, index) => (
                    <MenuItem key={index} value={`${data.id}`}>
                      {data.step_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="ถึง"
                variant="outlined"
                placeholder="ถึง"
                value={recipientName}
                InputProps={{ readOnly: true }}
                disabled={true}
                sx={{
                  '.Mui-disabled': {
                    color: '#65748B',
                    opacity: 1,
                    '-webkit-text-fill-color': '#65748B'
                  },
                  '.MuiInputLabel-root': {
                    color: '#65748B',
                    '-webkit-text-fill-color': '#65748B'
                  }
                }}
              />
              {/* <FormControl fullWidth>
                <InputLabel>ถึง</InputLabel>
                <Select
                  label="ถึง"
                  variant="outlined"
                  onChange={(e) => setRecipientId(parseInt(e.target.value))}
                  value={`${recipientId}`}
                  autoComplete="off"
                  required
                >
                  {recipientList.map((data, index) => (
                    <MenuItem key={index} value={`${data.id}`}>
                      {data.recipient_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="หัวข้อ"
                variant="outlined"
                placeholder="หัวข้อ"
                onChange={(e) => setSubject(e.target.value ? e.target.value : '')}
                value={subject}
                required
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="เนื้อหา (HTML Template)"
                placeholder="เนื้อหา (HTML Template)"
                multiline
                value={body ? body : ''}
                onChange={(e) => setBody(e.target.value ? e.target.value : '')}
                minRows={2}
                maxRows={4}
              />
              <Button
                variant="outlined"
                onClick={() => setIsShowKeywordModal(true)}
                sx={{ marginTop: 2 }}
              >
                แสดงตารางแผนผัง template keywords
              </Button>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            {/* <Grid item xs={6}>
              <Button
                variant="contained"
                color="error"
                sx={{ marginTop: 3 }}
                onClick={handleDelete}
              >
                ลบ
              </Button>
            </Grid> */}
            <Grid container item xs={12} sx={{ justifyContent: 'end' }}>
              <Button type="submit" variant="contained" color="primary" sx={{ marginTop: 3 }}>
                แก้ไข
              </Button>
            </Grid>
          </Grid>
        </Form>
      </Paper>

      <Paper sx={{ mt: 2 }}>
        <Typography variant="h6" sx={{ p: 2, pb: 0, m: 0, textAlign: 'center' }}>
          {'ตัวอย่างเนื้อหา Email'}
        </Typography>
        <Box sx={{ p: 2 }}>
          <Box border={'GrayText'}>
            <iframe
              srcDoc={body ? templateToHtml(body, mapKeywords) : ''}
              style={{
                width: '100%',
                minHeight: 500,
                backgroundColor: '#FFFFFF',
                // transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                // borderRadius: 8,
                // boxShadow:
                //   '0px 1px 1px rgb(100 116 139 / 6%), 0px 1px 2px rgb(100 116 139 / 10%)',
                borderWidth: 0.25,
                borderColor: '#ccc'
                // pointerEvents: 'none'
              }}
              sandbox=""
            ></iframe>
          </Box>
        </Box>
      </Paper>
      {/* </Container> */}
      <Modal
        open={isShowKeywordModal}
        onClose={() => setIsShowKeywordModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ModalContainer sx={{ p: 0 }}>
          <Table sx={{}} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Keyword</TableCell>
                <TableCell>ความหมาย</TableCell>
                <TableCell>ตัวอย่าง</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {EmailTemplateMapKeywords.map((keyword, index) => (
                <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell component="th" scope="row">
                    {keyword}
                  </TableCell>
                  <TableCell>{keyword in mapKeywords ? mapKeywordsMeaning[keyword] : ''}</TableCell>
                  <TableCell>{keyword in mapKeywords ? mapKeywords[keyword] : ''}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </ModalContainer>
      </Modal>
    </RootContainer>
  );
};

export default EditEmailTemplate;

const RootContainer = styled('div')`
  padding: 24px;
`;

const Form = styled('form')`
  display: flex;
  flex-direction: column;
  align-items: end;
`;

const ModalContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  transform: 'translate(-50%, -50%)',
  backgroundColor: '#fff',
  boxShadow: '0 3px 10px rgb(0 0 0 / 0.2)',
  // borderRadius: 16,
  padding: 16,
  width: '70%',
  maxHeight: '80%',
  overflow: 'auto'
}));
